/**
 * launch_url 编辑器：targeting_id=`、`-joined 渠道 id 列表，ext_info=marker
 * `launch_url_portal`（只读）。渠道 id chips + 类别 marker 展示。
 */
import type { EditorProps } from "./types";
import { IdChips } from "./IdChips";
import { joinDy, splitDy } from "../../utils/redlineHelpers";

export function IdListEditor({ item, onChange }: EditorProps) {
  const ids = splitDy(item.targeting_id);

  return (
    <div className="space-y-2">
      <IdChips
        ids={ids}
        onChange={(next) =>
          onChange({ targeting_id: joinDy(next), ext_info: item.ext_info ?? "" })
        }
        placeholder="输入渠道 id，回车添加"
      />
      <div className="text-[11px] text-text-muted">
        类别（ext_info）：
        <span className="leo-tag ml-1">{item.ext_info || "—"}</span>
        （marker，不可编辑）
      </div>
    </div>
  );
}
